import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import i18n from '@/locales/init';
import type { ExamLoadingStatus } from '../../useExamLoading';
import style from './index.module.less';

type ExamLoadingNoticeProps = {
  status: ExamLoadingStatus;
  onRetry: () => void;
};

export default function ExamLoadingNotice({status, onRetry}: ExamLoadingNoticeProps) {
  if (status === 'ready') return null;

  const retrying = status === 'retrying';
  return (
    <div className={style.notice} role="status" aria-live="polite">
      <Spin indicator={<LoadingOutlined spin />} />
      <span>{i18n.t(retrying ? 'common.dauyan_exam_load_retrying' : 'common.dauyan_exam_loading')}</span>
      {retrying && (
        <button type="button" className={style.retryButton} onClick={onRetry}>
          {i18n.t('common.dauyan_exam_load_retry')}
        </button>
      )}
    </div>
  );
}
